export default __webpack_public_path__ + "static/media/hocduong.e5b957b2.png";